<template>
  <div class="ab-banner" :class="[place, $config.platform, { side: sideBanner || $store.state.layout === 'mobile', long: longBanner && $store.state.layout !== 'mobile', calculatorsSide }]">
    <nuxt-link :to="url" class="banner-link" data-event="banner.click">
      <div class="banner-content">
        <div class="banner-title">
          <p class="first">
            <span class="dash left-dash" />{{ first }}<span class="dash right-dash" />
          </p>
          <p class="second">
            {{ second }}
          </p>
          <p class="title">
            {{ title }}
          </p>
          <p class="third">
            {{ third }}
          </p>
        </div>
        <div class="banner-description">
          <p v-if="$config.platform === 'ds'">
            Learn with instructors from:
          </p>
          <p v-else>
            Тaught by <span>Industry Experts</span> from:
          </p>
          <div v-if="$config.platform === 'ds'" class="companies">
            <LogoMeta />
            <LogoG />
            <LogoSpotify />
            <LogoNetflix />
            <LogoIkea />
            <LogoCocaCola />
          </div>
          <div v-else class="companies">
            <LogoHsbc />
            <LogoMorganStanley />
            <LogoGoldmanSachs />
            <LogoPwc class="pwc" />
            <LogoCocaCola />
            <LogoIkea />
          </div>
          <button class="btn-primary btn-3d">
            Get 25% OFF
          </button>
          <div class="rating-holder">
            <IconTrustpilot class="trustpilot" />
            <span class="text">
              {{ $config.platform === 'ds' ? '4.9/5' : '4.8/5' }}
            </span>
            <Rating :scale="4.9" />
          </div>
        </div>
      </div>
    </nuxt-link>
  </div>
</template>

<script>
import Rating from './Rating';
import LogoMeta from './assets/svg/companies/logo-meta.svg?vue-component';
import LogoCocaCola from './assets/svg/companies/logo-coca-cola-white.svg?vue-component';
import LogoG from './assets/svg/companies/logo-g.svg?vue-component';
import LogoSpotify from './assets/svg/companies/logo-spotify.svg?vue-component';
import LogoNetflix from './assets/svg/companies/logo-netflix.svg?vue-component';
import LogoIkea from './assets/svg/companies/logo-ikea.svg?vue-component';
import LogoGoldmanSachs from './assets/svg/companies/logo-goldman-sachs.svg?vue-component';
import LogoHsbc from './assets/svg/companies/logo-hsbc.svg?vue-component';
import LogoMorganStanley from './assets/svg/companies/logo-morgan-stanley.svg?vue-component';
import LogoPwc from './assets/svg/companies/logo-pwc.svg?vue-component';
import IconTrustpilot from './assets/svg/icon-trustpilot.svg?vue-component';

export default {
  components: {
    Rating, LogoMeta, LogoCocaCola, LogoG, LogoSpotify, LogoNetflix, LogoIkea, LogoGoldmanSachs, LogoHsbc, LogoMorganStanley, LogoPwc, IconTrustpilot,
  },
  props: {
    first: {
      type: String, default: '', required: true,
    },
    second: {
      type: String, default: '', required: true,
    },
    title: {
      type: String, default: '', required: true,
    },
    third: {
      type: String, default: '', required: false,
    },
    sideBanner: {
      type: Boolean,
    },
    longBanner: {
      type: Boolean,
    },
    place: {
      type: String, required: false, default: '',
    },
  },
  data() {
    return {
      calculatorsSide: '',
    };
  },
  computed: {
    url() {
      let extension = '';
      if (this.$route.path.includes('/question/') || this.$route.path.includes('/qa-hub/')) {
        extension = 'qa-hub-instructors-courses';
      }
      if (this.$route.path.includes('/resources-center/')) {
        extension = 'resources-instructors-courses';
      }
      if (this.$route.name === 'blogCategory-blogSubItem') {
        extension = 'blog-instructors-courses';
      }
      if (this.$route.path.includes('/calculators/')) {
        extension = 'calculators-instructors-courses';
      }
      return `/start-learning-m/?utm_medium=web&utm_source=banner&utm_campaign=banner-${extension}`;
    },
  },
  mounted() {
    if (this.$route.path.includes('/calculators/') && this.$store.state.layout === 'mobile') {
      this.calculatorsSide = 'side';
    }
  },
};
</script>

<style lang="scss">
.ab-banner {
  .banner-link {
    color: var(--main-light);

    &:active {
      .btn-3d {
        transition: all 0.2s ease-in;
        box-shadow: none;
        transform: translate(7px, 7px);
      }
    }
  }

  .banner-title {
    p {
      margin: 0;
    }

    .first,
    .second,
    .third {
      color: var(--main-dark);
    }

    .first {
      margin-bottom: var(--spacing-4);
      display: flex;
      align-items: center;

      .dash {
        display: inline-block;
        width: 42px;
        height: 1px;
        background: var(--main-dark);

        &.right-dash {
          margin-left: var(--spacing-8);
        }

        &.left-dash {
          margin-right: var(--spacing-8);
        }
      }
    }

    .title {
      margin: var(--spacing-12) 0;
      color: var(--main-light);
      text-shadow: 2px 2px 1.7px rgba(0, 0, 0, 0.8);
    }
  }

  .banner-description {
    padding: var(--spacing-20) var(--spacing-30) var(--spacing-24);
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
    background: linear-gradient(135deg, rgba(86, 191, 199, 0.2) 0.94%, rgba(86, 191, 199, 0) 100%), #141F31;

    p {
      color: var(--accent-light-3);
      text-align: center;
      font-weight: 500;
      letter-spacing: 0.16px;
      margin: 0;
      margin-bottom: var(--spacing-12);
    }

    .btn-3d {
      margin: var(--spacing-8) 0 15px;
      position: relative;
      width: calc(100% - 7px);
      height: 49px;
      font-size: 26px;
      font-weight: 600;
      letter-spacing: 0.52px;
      line-height: 26px;
      cursor: pointer;
      padding: 0;
      color: var(--main-dark);
      border-radius: 7px;
      display: flex;
      align-items: center;
      justify-content: center;
      border: none;
      background: #FBD914;
      box-shadow:
        0 0 0 #DFB726,
        1px 1px 0 #DFB726,
        2px 2px 0 #DFB726,
        3px 3px 0 #DFB726,
        4px 4px 0 #DFB726,
        5px 5px 0 #DFB726,
        6px 6px 0 #DFB726,
        7px 7px 0 #DFB726;

      &:hover {
        background: #FBD914;
        color: var(--main-dark);
      }

      &:active {
        transition: all 0.2s ease-in;
        box-shadow: none;
        transform: translate(7px, 7px);
      }
    }

    .companies {
      display: flex;
      flex-flow: wrap;
      column-gap: 15px;

      svg {
        height: 14px;

        &.pwc path[fill] {
          fill: var(--main-light);
        }
      }
    }

    .rating-holder {
      display: flex;
      align-items: center;
      justify-content: center;

      .trustpilot {
        height: 24px;
      }

      .text {
        font-size: 16px;
        font-weight: 500;
        line-height: 140%;
        color: var(--main-light-shade-4);
        margin-left: var(--spacing-16);
        margin-right: var(--spacing-12);
      }

      .text,
      .rating {
        margin-top: 8px;
      }
    }
  }

  &.side {
    .banner-title {
      text-align: center;
      background-image: url('./assets/images/site-ad-banner-mobile.webp');
      height: 331px;
      background-repeat: no-repeat;
      background-size: cover;
      border-top-left-radius: 10px;
      border-top-right-radius: 10px;
      padding-top: var(--spacing-20);
      text-transform: uppercase;
      border-bottom: 4px solid #EDC843;

      .first {
        justify-content: center;
      }
    }

    .banner-description {
      .text,
      .rating {
        margin-top: 8px;
      }
    }
  }

  &.long {
    .banner-content {
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-radius: 10px;
      width: 100%;
      height: 184px;
      overflow: hidden;
      background-image: url('./assets/images/site-ad-banner-desktop.webp');

      .banner-title {
        background-image: none;
        height: 100%;
        padding: var(--spacing-24) var(--spacing-20);

        .first {
          text-align: left;
          font-size: 20px;
          font-weight: 500;
          line-height: 110%;

          .left-dash {
            display: none;
          }
        }

        .second {
          font-size: 24px;
          font-weight: 600;
          line-height: 85%;
          text-transform: uppercase;
        }

        .title {
          font-size: 50px;
          font-weight: 700;
          line-height: 75%;
          letter-spacing: -0.5px;
          text-transform: uppercase;
          margin-top: var(--spacing-8);
        }

        .third {
          font-size: 32px;
          font-weight: 600;
          line-height: 82%;
          text-transform: uppercase;
        }
      }

      .banner-description {
        height: 100%;
        padding-left: var(--spacing-40);
        padding-right: var(--spacing-40);
        border-left: 4px solid var(--main-yellow);
        border-radius: 0;
      }
    }
  }

  &.qa-hub {
    margin-bottom: 30px;

    .banner-title {
      .first {
        font-size: 20px;
        line-height: 18px;
        font-weight: 500;

        .dash {
          width: 60px;
        }
      }

      .second {
        font-size: 24px;
        line-height: 20px;
        font-weight: 600;
      }

      .title {
        font-size: 44px;
        line-height: 40px;
        font-weight: 700;
        letter-spacing: -0.5px;
      }

      .third {
        font-size: 32px;
        line-height: 26px;
        font-weight: 600;
      }
    }

    &.fa {
      .banner-title {
        background-image: url('./assets/images/site-ad-banner-mobile-fa.webp');

        .title {
          font-size: 36px;
          line-height: 98%;
        }
      }

      .banner-description {
        background: var(--main-dark-light-2);

        p {
          color: var(--accent-light-2);

          span {
            color: #FBD914;
          }
        }

        span {
          color: var(--main-light-shade-4);
        }

        .companies {
          column-gap: 2px;
        }
      }
    }
  }
}

@include bp($bp-laptop) {
  .ab-banner.side {
    .banner-title {
      height: 277px;

      .title {
        margin: 9px 0;
      }
    }

    .banner-description {
      .companies {
        row-gap: 12px;
        justify-content: center;

        svg {
          height: 19px;
        }
      }

      .rating-holder {
        .trustpilot {
          height: 22px;
        }

        .text {
          font-size: 14px;
          margin-left: var(--spacing-12);
          margin-right: 7px;
        }

        .rating {
          svg {
            height: 18px;
          }
        }
      }
    }
  }

  .ab-banner.long {
    .banner-content {
      background-image: url('./assets/images/site-ad-banner-laptop.webp');

      .banner-title .title {
        font-size: 48px;
      }

      .banner-description {
        padding: var(--spacing-22) var(--spacing-16);

        p {
          font-size: 14px;
        }

        .companies {
          column-gap: 9px;

          svg {
            height: 12px;
          }
        }

        .btn-3d {
          font-size: 24px;
        }

        .rating-holder {
          .trustpilot {
            height: 20px;
          }
        }
      }
    }
  }

  .ab-banner.qa-hub {
    .banner-title {
      .first {
        font-size: 15px;
        line-height: 16px;
        font-weight: 500;

        .dash {
          width: 42px;
        }
      }

      .second {
        font-size: 18px;
        line-height: 20px;
        font-weight: 600;
      }

      .title {
        font-size: 38px;
        line-height: 33px;
        font-weight: 700;
        letter-spacing: -0.38px;
      }

      .third {
        font-size: 24px;
        line-height: 23px;
        font-weight: 600;
      }
    }

    &.fa {
      .banner-title {
        .title {
          font-size: 30px;
        }
      }
    }
  }
}

@include bp($bp-mobile) {
  .ab-banner.side {
    .banner-title {
      height: 294px;
      background-position: center;

      .title {
        margin: 9px 0;
      }
    }

    .banner-description {
      padding: 18px 26px 21px;

      .companies {
        column-gap: 7px;
        justify-content: center;

        svg {
          height: 15px;
        }
      }

      .rating-holder {
        .trustpilot {
          height: 22px;
        }

        .text {
          font-size: 14px;
          margin-left: var(--spacing-12);
          margin-right: 7px;
        }

        .rating {
          svg {
            height: 18px;
          }
        }
      }
    }
  }

  .ab-banner.qa-hub {
    .banner-title {
      .first {
        font-size: 18px;
        line-height: 20px;
        font-weight: 500;

        .dash {
          width: 45px;
        }
      }

      .second {
        font-size: 20px;
        line-height: 20px;
        font-weight: 600;
      }

      .title {
        font-size: 38px;
        line-height: 32px;
        font-weight: 700;
        letter-spacing: -0.38px;
      }

      .third {
        font-size: 28px;
        line-height: 22px;
        font-weight: 600;
      }
    }
  }
}
</style>
